import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import type {PayloadAction} from '@reduxjs/toolkit'
import axios from 'axios'

const post = axios.post

const handleRequest = async (request: Promise<any>, thunkAPI: any) => {
  try {
    const res = await request
    return res.data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response.data)
  }
}

export const forgotPassword = createAsyncThunk('forgot-pwd', (params: {}, thunkAPI) =>
  handleRequest(post('/api/forgot-password', params), thunkAPI)
)

export const resetPassword = createAsyncThunk('reset-pwd', (params: {}, thunkAPI) =>
  handleRequest(post(`/api/reset-password`, params), thunkAPI)
)

type ErrorState = {
  errors: any
}

const initialState: ErrorState = {
  errors: '',
}

export const passwordSlice = createSlice({
  name: 'password',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(forgotPassword.fulfilled, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
    builder.addCase(resetPassword.fulfilled, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
  },
})

export const {reset} = passwordSlice.actions
export default passwordSlice.reducer
